import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../hooks/useAppDispatch'
import { Tabs } from '../components/ui'

import { AdminOverview }         from '../features/admin/AdminOverview'
import { AdminUsers }            from '../features/admin/AdminUsers'
import { AdminAgentsHub }        from '../features/admin/AdminAgentsHub'
import { AdminModerationHub }    from '../features/admin/AdminModerationHub'
import { AdminAnalyticsHub }     from '../features/admin/AdminAnalyticsHub'
import { AdminCommunicationHub } from '../features/admin/AdminCommunicationHub'
import { AdminCategories }       from '../features/admin/AdminCategories'
import { AdminCache }            from '../features/admin/AdminCache'
import { AdminDocuments }        from '../features/admin/AdminDocuments'

import s from '../styles/pages/AdminPage.module.css'

// Each of agents/moderation/analytics/communication bundles a few of the old
// flat tabs behind a PillTabs sub-nav (see the matching *Hub.tsx components) —
// reports+moderation were literally the same domain (report queue vs. report-
// reason config), and costs/ai-usage/monetization are all money/usage lenses
// on the same underlying data, so they no longer need separate top-level tabs.
const TABS = [
  'overview', 'users', 'agents', 'moderation',
  'analytics', 'communication', 'categories', 'documents',
] as const

type Tab = typeof TABS[number]

export default function AdminPage() {
  const { user } = useAppSelector((s) => s.auth)
  const [activeTab, setActiveTab] = useState<Tab>('overview')

  if (!user?.roles.includes('admin')) return <Navigate to="/" replace />

  return (
    <div>
      <div className={s.pageHeader}>
        <h1>🛡️ Admin Panel</h1>
        <p>Manage agents, users, categories, and content moderation</p>
      </div>

      <Tabs
        tabs={TABS.map(tab => ({ key: tab, label: tab.charAt(0).toUpperCase() + tab.slice(1) }))}
        active={activeTab}
        onChange={(t) => setActiveTab(t as Tab)}
        style={{ marginBottom: '1.5rem' }}
      />

      {activeTab === 'overview'      && <AdminOverview />}
      {activeTab === 'users'         && <AdminUsers />}
      {activeTab === 'agents'        && <AdminAgentsHub />}
      {activeTab === 'moderation'    && <AdminModerationHub />}
      {activeTab === 'analytics'     && <AdminAnalyticsHub />}
      {activeTab === 'communication' && <AdminCommunicationHub />}
      {activeTab === 'categories'    && <AdminCategories />}
      {activeTab === 'documents'     && <AdminDocuments />}
    </div>
  )
}
